import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCrown = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			rx: 10,
			fill: "#F59E0B"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.99452 6.58783L5.66539 12.3129L13.0735 13.6192L14.7223 8.12677L12.4238 9.13529L10.6862 5.49841L7.80948 8.32165L5.99452 6.58783ZM5.899 5.056L7.79971 6.87172L10.477 4.24422C10.6823 4.04274 11.0121 4.04584 11.2135 4.25113C11.2538 4.29215 11.2869 4.33955 11.3118 4.39142L12.9289 7.77614L15.336 6.71999C15.5994 6.60443 15.9066 6.72426 16.0222 6.98768C16.0719 7.10095 16.0797 7.22822 16.0441 7.34669L13.938 14.3623C13.8621 14.6152 13.6088 14.7713 13.3487 14.7255L5.02839 13.2584C4.7683 13.2125 4.58371 12.9792 4.59886 12.7155L5.01926 5.40271C5.03577 5.11554 5.28195 4.89612 5.56912 4.91263C5.69262 4.91973 5.80956 4.97055 5.899 5.056ZM9.73124 10.9144C9.16467 10.8145 8.78638 10.2742 8.88628 9.70767C8.98618 9.14109 9.52643 8.76281 10.093 8.86271C10.6595 8.9626 11.0379 9.50286 10.938 10.0694C10.8381 10.636 10.2978 11.0143 9.73124 10.9144Z",
			fill: "white"
		})
	]
});
const ForwardRef = forwardRef(SvgCrown);
export { ForwardRef as ReactComponent };
